import { useEffect, useState, useRef } from "react"
import AddDebtRow from "./AddDebtRow";
import { validateBeforeSend } from "../debtUtilities";
import useCreadyApi from "../utils/Api";
import { useNavigate } from 'react-router-dom';
import { PlusIcon } from '@heroicons/react/24/outline'

export default function DebtCreator(props) {
    // Load debts from localStorage
    var debtsJson = localStorage.getItem('debts');
    let debts = null;
    if (debtsJson != "undefined") {
        debts = JSON.parse(debtsJson);
    }
    if (debts == null) {
        debts = [];
    }

    try {
        debts.map(m => m);
    } catch {
        debts = [];
    }

    const [debtsws, setDebts] = useState(debts);
    const [isAdding, setIsAddning] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const [editingDebt, setEditingDebt] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPopup, setShowPopup] = useState(false);

    const isSubmittingRef = useRef(false);
    const navigate = useNavigate();
    const api = useCreadyApi();

    // Handle adding/editing rows
    function rowChanged(cancelled, debt) {
        if (!cancelled && debt) {
            debtsws[debt.id] = debt;
            setDebts([...debtsws]);
            localStorage.setItem('debts', JSON.stringify(debtsws));
        }
        setIsAddning(false);
        setEditingDebt(null);
        setIsEditing(false);
    }

    function startEditing(debtId) {
        setEditingDebt(debtsws[debtId]);
        setIsEditing(true);
    }


    // Validate and submit data
    async function validateAndSend() {
        if (isSubmittingRef.current) return;

        const savedData = localStorage.getItem('debtCreationData');
        const debts = localStorage.getItem('debts');

        if (!debts || debts.length === 0) {
            alert("Du måste minst lägga till en skuld");
        } else if (savedData) {
            try {
                isSubmittingRef.current = true;
                setIsSubmitting(true);
                var obj = JSON.parse(savedData);
                obj.debts = JSON.parse(debts);
                var data = validateBeforeSend(obj);
                var res = await api.debts.create(data.data);

                if (res.id) {
                    localStorage.setItem('debtCreationData', JSON.stringify({}));
                    localStorage.setItem('debts', JSON.stringify([]));
                    localStorage.setItem('debtCreationStep', '0');
                    navigate('/debts/' + res.id);
                }
            } finally {
                setIsSubmitting(false);
                isSubmittingRef.current = false;
            }
        }
    }

    return (
        <div className="px-[14rem] w-4/7">
           

            {/* Step header and add debt button */}
            <div className="mt-6 sm:flex sm:items-center">
                <div className="sm:flex-auto">
                    <h1 className="text-2xl font-semibold leading-6 text-gray-900">2. Skulder (steg 2/2)</h1>
                </div>
                <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
                    <button
                        onClick={() => setIsAddning(true)}
                        type="button"
                        className="inline-flex items-center px-6 py-2.5 text-sm font-semibold text-center text-blue-1 hover:bg-blue-1 align-middle transition-all duration-100 ease-in-out bg-transparent border-2 border-blue-1 border-solid rounded-md cursor-pointer hover:text-white shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-blue-1"
                    >
                        <PlusIcon stroke="currentColor" className="h-5 w-5 mr-1.5" aria-hidden="true" />
                        Lägg till faktura
                    </button>
                </div>
            </div>

            {/* Debts table */}
            <div className="-mx-4 mt-8 flow-root sm:mx-0">
                <table className="min-w-full">
                    <colgroup>
                        <col className="w-full sm:w-1/2" />
                        <col className="sm:w-1/6" />
                        <col className="sm:w-1/6" />
                        <col className="sm:w-1/6" />
                    </colgroup>
                    <thead className="border-b border-gray-300 text-gray-900">
                        <tr>
                            <th className="py-3.5 pr-3 text-left text-sm font-semibold text-gray-900">Faktura</th>
                            <th className="hidden px-3 py-3.5 text-sm text-left font-semibold text-gray-900 sm:table-cell">Fakturadatum</th>
                            <th className="hidden px-3 py-3.5 text-sm text-left font-semibold text-gray-900 sm:table-cell">Förfallodatum</th>
                            <th className="hidden px-3 py-3.5 text-sm text-left font-semibold text-gray-900 sm:table-cell">Påminnelse</th>
                            <th className="hidden px-3 py-3.5 text-sm text-left font-semibold text-gray-900 sm:table-cell">Kapitalbelopp (inkl. moms)</th>
                            <th className="hidden px-3 py-3.5 text-sm text-left font-semibold text-gray-900 sm:table-cell">Delbetalning</th>
                        </tr>
                    </thead>
                    <tbody>
                        {debtsws.map((debt) => (
                            <tr key={debt.id} className="border-b border-gray-200 hover:bg-zinc-100 hover:cursor-pointer" onClick={() => startEditing(debt.id)}>
                                <td className="max-w-0 py-5 pr-3 text-sm">
                                    <div className="font-medium text-gray-900">{debt.invoiceid}</div>
                                    <div className="mt-1 truncate text-gray-500">{debt.description}</div>
                                </td>
                                <td className="hidden px-3 py-5 text-sm text-gray-500 sm:table-cell">{debt.invoiceDate}</td>
                                <td className="hidden px-3 py-5 text-sm text-gray-500 sm:table-cell">{debt.dueDate}</td>
                                <td className="hidden px-3 py-5 text-sm text-gray-500 sm:table-cell">{debt.reminder}</td>
                                <td className="hidden px-3 py-5 text-sm text-gray-500 sm:table-cell">{debt.capital}</td>
                                <td className="hidden px-3 py-5 text-sm text-gray-500 sm:table-cell"> {debt.payments.length > 0 ? "Ja" : "Nej"}</td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <th scope="row" colSpan={3} className="hidden pl-4 pr-3 pt-4 text-right text-sm font-semibold text-gray-900 sm:table-cell sm:pl-0">Totalt</th>
                            <th scope="row" className="pl-4 pr-3 pt-4 text-left text-sm font-semibold text-gray-900 sm:hidden">Totalt</th>
                            <td className="pl-3 pr-4 pt-4 text-right text-sm font-semibold text-gray-900 sm:pr-0">{debtsws.reduce((acc, item) => acc + parseFloat(item.capital), 0)} SEK</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            {/* Add/Edit Debt Row */}
            {isAdding && <AddDebtRow notifyParent={rowChanged} id={debtsws.length} />}
            {isEditing && editingDebt && <AddDebtRow notifyParent={rowChanged} debt={editingDebt} />}

            {/* Submit Button */}
            <div className="mt-20 flex justify-between items-center gap-4 mb-10">

                {/* Tillbaka - längst till vänster */}
                <button
                    onClick={() => props.notifyParent(true)}
                    type="button"
                    className="rounded-md border-2 border-darkgrey px-4 py-2.5 text-sm font-semibold text-black shadow-sm hover:bg-neutral-500 hover:bg-opacity-5"
                >
                    {"<- Tillbaka"}
                </button>

                {/* Högerknappar: Avbryt + Skicka */}
                <div className="flex gap-4">
                    <button
                        type="button"
                        onClick={() => setShowPopup(true)}
                        className="px-6 py-2.5 text-sm font-semibold text-red border-2 border-red rounded-md hover:bg-red hover:text-white transition-all"
                    >
                        Avbryt
                    </button>

                    <button
                        onClick={validateAndSend}
                        type="button"
                        disabled={isSubmitting}
                        className={`px-6 py-2.5 text-sm font-semibold rounded-md border-2 shadow-sm cursor-pointer
        ${isSubmitting
                                ? "bg-gray-300 border-gray-300 text-gray-500 cursor-not-allowed"
                                : "bg-blue-1 border-blue-1 text-white hover:bg-transparent hover:text-blue-1"
                            }`}
                    >
                        {isSubmitting ? "Skickar..." : "Skicka in ärende"}
                    </button>
                </div>

            </div>



            {/* Popup */}
            {showPopup && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg shadow-xl max-w-sm w-full px-4 pb-4 pt-4 ">
                        <h3 className="text-lg font-semibold mb-4 mt-3">Avbryt registrering av inkassoärendet</h3>
                        <p className="text-gray-900 mb-4">Är du säker på att du vill avbryta registreringen av inkassoärendet?</p>
                        <div className="mt-5 sm:mt-6 sm:grid sm:grid-flow-row-dense sm:grid-cols-2 sm:gap-3">
                            <button
                                className="inline-flex items-center mt-1 justify-center px-4 py-2.5 mb-4 text-m font-semibold text-white bg-red rounded-md hover:bg-transparent hover:text-red border-2 border-red shadow-sm"
                                onClick={() => { setShowPopup(false); props.resetTrigger(); }}
                            >
                                Ja, avbryt
                            </button>

                            <button
                                className="inline-flex mt-1 justify-center pl-6 pr-4 py-2.5 mb-4 text-m font-semibold text-blue-2 bg-transparent hover:bg-blue-2 hover:text-white border-2 border-blue-2 rounded-md shadow-sm"
                                onClick={() => setShowPopup(false)}
                            >
                                Nej, fortsätt registrering
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
